import { setSelectedDealer } from "components";
import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Dealer } from "models";

export type UpdateDealerPayload = Dealer & {
  pon_oil_password?: string;
  lef_password?: string;
};

const hasSecret = (secret: string | undefined, hadSecret?: boolean) => (secret === undefined ? hadSecret : !!secret);

export const useUpdateDealerMutation = () =>
  useTypedMutation<UpdateDealerPayload, void>({
    mutationFn: async payload => (await ApiInstance.post("/dealers/update", payload, ENV.dealerBaseURL)).data,
    onSuccess: ({ pon_oil_password, lef_password, ...payload }) => {
      const updatedDealer: Dealer = {
        ...payload,
        has_pon_password: payload.is_pon_enabled && hasSecret(pon_oil_password, payload.has_pon_password),
        has_lef_password: hasSecret(lef_password, payload.has_lef_password)
      };

      const dealers = typedQueryClient.getQueryData(DealersDashboardQueryKeys.list);
      const listDealerIdx = dealers?.findIndex(dealer => dealer.id === updatedDealer.id) ?? -1;

      if (dealers && listDealerIdx !== -1)
        typedQueryClient.setQueryData(DealersDashboardQueryKeys.list, dealers.with(listDealerIdx, { ...dealers[listDealerIdx], ...updatedDealer }));

      typedQueryClient.setQueryData(DealersDashboardQueryKeys.dealerDetails(updatedDealer.id), updatedDealer);
      typedQueryClient.invalidateQueries(DealersDashboardQueryKeys.dealerDetails(updatedDealer.id));

      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === updatedDealer.id) ?? -1;

      if (dealersList && dealerIdx !== -1)
        typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
          ...dealersList,
          dealers: dealersList.dealers.with(dealerIdx, { ...dealersList.dealers[dealerIdx], ...updatedDealer })
        });

      const selectedDealer = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.selectedDealer);
      if (selectedDealer?.id !== updatedDealer.id) return;

      setSelectedDealer({ ...selectedDealer, ...updatedDealer });
    }
  });
